export default "__VITE_ASSET__d69a5c75__"